import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { FullScreenLoading } from "@/components/common/Loading";

export function ProtectedRoute({ requireOnboarded = true }: { requireOnboarded?: boolean }) {
  const { isAuthenticated, isLoading, isOnboarded } = useAuth();
  const location = useLocation();

  if (isLoading) return <FullScreenLoading />;
  if (!isAuthenticated) {
    return <Navigate to="/welcome" replace state={{ from: location }} />;
  }
  if (requireOnboarded && !isOnboarded && !location.pathname.startsWith("/auth/onboarding")) {
    return <Navigate to="/auth/onboarding" replace />;
  }
  return <Outlet />;
}

export function AdminRoute() {
  const { isAdmin, isLoading, isAuthenticated } = useAuth();
  if (isLoading) return <FullScreenLoading />;
  if (!isAuthenticated) return <Navigate to="/welcome" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}

export function PublicOnlyRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <FullScreenLoading />;
  if (isAuthenticated) return <Navigate to="/" replace />;
  return <Outlet />;
}
